import * as React from 'react'
import {
  getStateFromPath,
  getActionFromState,
  NavigationContext
} from '@react-navigation/core'
import { LinkingContext } from '@react-navigation/native'
import { Linking, Platform } from 'react-native'
import analytics from './libraries/analytics'
import { InAppBrowser } from 'react-native-inappbrowser-reborn'
export default function useLinkTo(_navigation = null) {
  let navigationFromContext = React.useContext(NavigationContext)
  let navigation = _navigation ?? navigationFromContext

  // debugger
  if (!navigation) {
    if (global._navigation) {
      navigation = global._navigation
    }
  }
  let linking = React.useContext(LinkingContext)
  const linkTo = React.useCallback(
    async (path, forcePush = false) => {
      if (!path) {
        console.warn('Nullish path, exiting')
        return
      }
      if (typeof path === 'function') {
        path()
        return
      }
      if (!path.startsWith('/')) {
        // we can pop them out to a new window.

        if (path.startsWith('http')) {
          // probably an external link.
          if (Platform.OS == 'web') {
            window.open(path, '_blank')
            return
          } else {
            if (InAppBrowser && (await InAppBrowser.isAvailable())) {
              await InAppBrowser.open(path, {
                // iOS Properties
                dismissButtonStyle: 'cancel',
                readerMode: false,
                animated: true,
                modalPresentationStyle: 'fullScreen',
                modalTransitionStyle: 'coverVertical',
                modalEnabled: true,
                enableBarCollapsing: false,
                // Android Properties
                showTitle: true,
                enableUrlBarHiding: true,
                enableDefaultShare: true,
                forceCloseOnRedirection: false,
                // Specify full animation resource identifier(package:anim/name)
                // or only resource name(in case of animation bundled with app).
                animations: {
                  startEnter: 'slide_in_right',
                  startExit: 'slide_out_left',
                  endEnter: 'slide_in_left',
                  endExit: 'slide_out_right'
                }
              })
            } else {
              Linking.openURL(path)
            }
            return
          }
        } else {
          throw new Error("The path must start with '/' (".concat(path, ').'))
        }
      }

      if (!linking.options) {
        linking = global._linking
      }

      if (navigation === undefined) {
        throw new Error(
          "Couldn't find a navigation object. Is your component inside a screen in a navigator?"
        )
      }

      // handles old route type and new route type - mismatched cache to routing.
      if (path.startsWith('/entity/?type')) {
        path = path.split('/entity/?type').join('/entity-list/?type')
      }
      const { options } = linking
      const state =
        options !== null && options !== void 0 && options.getStateFromPath
          ? options.getStateFromPath(path, options.config)
          : getStateFromPath(
              path,
              options === null || options === void 0 ? void 0 : options.config
            )

      if (state) {
        let root = navigation
        let current // Traverse up to get the root navigation

        while ((current = root.dangerouslyGetParent())) {
          root = current
        }

        let action = getActionFromState(
          state,
          options === null || options === void 0 ? void 0 : options.config
        )

        const navState = navigation.dangerouslyGetState()

        let payloadName = action.payload.name
        let params = action.payload.params
        let deepestScreen
        while (params) {
          payloadName = params.screen ? params.screen : payloadName

          if (params.screen) {
            deepestScreen = params
          }

          params = params.params
        }

        const existsInStack = navState.routes.filter(
          (r) => r.name === payloadName
        ).length

        if (existsInStack || forcePush) {
          action.payload = { ...deepestScreen }
          action.payload.name = deepestScreen.screen
          action.type = 'PUSH'
        }

        if (action !== undefined) {
          analytics.TrackEvent('Navigate to', {
            screen: deepestScreen.screen,
            ...deepestScreen.params
          })
          root.dispatch(action)
        } else {
          root.reset(state)
        }
      } else {
        throw new Error('Failed to parse the path to a navigation state.')
      }
    },
    [linking, navigation]
  )
  return linkTo
}

export const useBetterLinkTo = useLinkTo

//# sourceMappingURL=useLinkTo.js.map
